<template>
  <div class="formula-formulate-adapter">
    <slot name="form" :fieldDefinitions="fieldDefinitions">
      <formulate-form :key="formulateKey" ref="form" v-model.lazy="input">
        <div class="flex gap-4 flex-col">
          <template v-for="(field) in fieldDefinitions">
            <formulate-field-adapter
              :disabled="viewOnly"
              :key="field.name"
              v-if="field.type !== 'group'"
              @mounted="loadFieldRef"
              :value="field"
              v-show="shouldShow(field.name)"
              :bindValidation="() => customValidation(field)"
            />
            <formulate-group-adapter
              @mounted-field="loadFieldRef"
              :disabled="viewOnly"
              :debug="debug"
              :key="field.name"
              v-else
              :value="field"
              :show-criteria="showCriteria"
            />
          </template>
        </div>
      </formulate-form>
    </slot>
  </div>
</template>

<script>


import { compileFields } from './compiler.ts'
import FormulateFieldAdapter from './FormulateFieldAdapter.vue'
import FormulateGroupAdapter from './FormulateGroupAdapter.vue'

export default {
  components: { FormulateFieldAdapter, FormulateGroupAdapter },
  props: {
    formDefinition: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Object,
      default: () => {}
    },
    debug: {
      type: Boolean,
      default: false
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    fieldDefinitions: [],
    input: {},
    showCriteria: {},
    nullClears: {},
    debouncedUpdate: null,
    fieldRefs: {}
  }),

  mounted() {
    this.input = this.value
  },

  watch: {
    value(val) {
      this.input = val
    },
    input(val) {
      this.debouncedUpdate(val)
    }
  },

  methods: {
    update(val) {
      this.updateShow()
      val = this.applyNullClears(val)
      this.$emit('input', val)
    },
    shouldShow(id) {
      return this.showCriteria && this.showCriteria[id]
    },
    applyNullClears(val) {
      Object.keys(val || {}).forEach((fieldId) => {
        const value = val[fieldId]

        const valueIsNullLike = (
          value === 'no' || value === 'na' || !value
        )

        if (valueIsNullLike) {
          const clearFields = this._.get(this, `nullClears.${fieldId}`, null)
          if (clearFields && this._.isArray(clearFields) && clearFields.length > 0) {
            clearFields.forEach((fieldIdToClear) => {
              if (val[fieldIdToClear]) {
                const field = this.fieldRefs[fieldIdToClear]
                if (field) field.clear()
              }
              delete val[fieldIdToClear]
            })
          }
        }

      })

      return val
    },
    updateShow() {
      const input = this.input
      this.formDefinition.head.render.forEach((definition) => {

        let showWhen = ('show_when' in (definition.params || {}) ? definition.params.show_when : true)
        let showWhenValue = ('show_when_value' in (definition.params || {}) ? definition.params.show_when_value : false)

        if (this._.isString(showWhen)) {
          const parentElement = showWhen
          if(parentElement in input){
            if(showWhenValue){
              const inputValue = input[parentElement]
              const isMatch = Array.isArray(inputValue)
                            ? inputValue.includes(showWhenValue) // Se for array, verifica se contém o valor
                            : inputValue == showWhenValue; // Se for valor único, compara diretamente

              showWhen = isMatch
            }else{
              showWhen = (input[parentElement] !== 'no' && input[parentElement] !== 'na' && !!input[parentElement])
            }
          } else {
            showWhen = false
          }
        }

        const nullClear = this._.get(definition, 'params.null_clears', null)

        if (nullClear) {
          this.$set(this.$data.nullClears, definition.id, this._.isArray(nullClear) ? [...nullClear] : [nullClear])
        }

        this.$set(this.$data.showCriteria, definition.id, showWhen)
      })
    },
    makeFieldDefinitions(formDefinition) {
      return compileFields(formDefinition)
    },
    loadFieldRef(fieldName, fieldRef) {
      this.$set(this.$data.fieldRefs, fieldName, fieldRef)
    },
    customValidation(field) {
        console.log('bindValidation...[field]:', field)
        //const validation = this._.get(this.field.render_params, 'validation', null)
        //const showWhen = this._.get(this.field.render_params, 'show_when', null)
       // const showWhenValue = this._.get(this.field.render_params, 'show_when_value', null)

        // Se o campo não tem validação específica, retorna `true`
        if (!validation) return true;

        // Se há dependência (show_when), aplica validação condicional
        /*
        if (!showWhen && !showWhenValue) {
            return validation
        }else{
          return validation
        }
        */
    }, // End bindValidation
  },

  beforeMount() {
    this.fieldDefinitions = this.makeFieldDefinitions(this.formDefinition)
    this.updateShow()
    this.debouncedUpdate = this._.debounce(
      this.update, 250
    )
  }
}
</script>

<style lang="scss">
.formula-formulate-adapter {
  @import "theme/snow/snow.scss";
  & .formulate-form h4 {
    padding-bottom: 0.5rem;
    padding-top: 0.5rem;
  }
}
</style>
